// src/context/AuthContext.tsx

import React, {
createContext,
useContext,
useEffect,
useState,
} from "react";
import { disconnectSignalR } from "../api/signalRClient";

type AuthContextType = {
token: string | null;
user: any | null;
isAuthenticated: boolean;
initialized: boolean;
setAuth: (
token: string | null,
user?: any | null
) => void;
logout: () => void;
};

const AuthContext = createContext<
AuthContextType | undefined

> (undefined);

export const AuthProvider: React.FC<{
children: React.ReactNode;
}> = ({ children }) => {
const [token, setToken] = useState<string | null>(
null
);
const [user, setUser] = useState<any | null>(
null
);
const [initialized, setInitialized] =
useState(false);

// Authentication is based on the user object.
const isAuthenticated = Boolean(user);

// Restore only the user from localStorage.
// JWT is expected to come from the HttpOnly cookie.
useEffect(() => {
const u = localStorage.getItem("user");


if (u) {
  try {
    setUser(JSON.parse(u));
  } catch {
    localStorage.removeItem("user");
  }
}

setInitialized(true);


}, []);

// Keep localStorage in sync with user state.
useEffect(() => {
if (!initialized) return;


if (user) {
  localStorage.setItem(
    "user",
    JSON.stringify(user)
  );
} else {
  localStorage.removeItem("user");
}


}, [user, initialized]);

const setAuth = (
t: string | null,
u: any | null = null
) => {
setToken(t ?? null);
setUser(u);


if (u) {
  localStorage.setItem(
    "user",
    JSON.stringify(u)
  );
} else {
  localStorage.removeItem("user");
}


};

const logout = () => {
setToken(null);
setUser(null);


localStorage.removeItem("token");
localStorage.removeItem("user");

disconnectSignalR();

setAuth(null, null);


};

return (
<AuthContext.Provider
value={{
token,
user,
isAuthenticated,
initialized,
setAuth,
logout,
}}
>
{children}
</AuthContext.Provider>
);
};

export interface AuthUser {
userNo: number;
userName: string;
email?: string;
userType?: string;
}

export function useAuth() {
const ctx = useContext(AuthContext);

if (!ctx) {
throw new Error(
"useAuth must be used within <AuthProvider>"
);
}

return ctx;
}
